import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBWIEy0-fsG0Mcl03n4ZzNdWimIpXe5dl0",
  authDomain: "deepfakeportal.firebaseapp.com",
  projectId: "deepfakeportal",
  storageBucket: "deepfakeportal.firebasestorage.app",
  messagingSenderId: "17052761033",
  appId: "1:17052761033:web:20b125d4a77145fb108618",
  measurementId: "G-X5QN8Z6G8P"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
